import React,{ useState} from 'react';
import {getMergeSortAnimations} from '../sortingAlgorithms/sortingAlgorithms.js';
import './SortingAnalyzer.css';

const ANIMATION_SPEED_MS = 3;
const NUMBER_OF_ARRAY_BARS = 275;

function SortingAnalyzer(){
   
    const[array,setnumber] = useState([]);

    function handleClick(){
        const array = [];
        for(let i=0;i<NUMBER_OF_ARRAY_BARS;i++){
            array.push( Math.floor(Math.random() * (400 - 5) + 5));
        }
         setnumber(array); 
     }
      
     function mergesort(){
       const animations = getMergeSortAnimations(array);
  
     
         for(let i=0;i<animations.length;i++){
            const arrayBars = document.getElementsByClassName('array-bar');
           const isColorChange = i%3 !== 2;
           if(isColorChange){
               const[barOneIdx,barTwoIdx] = animations[i];
               const barOneStyle = arrayBars[barOneIdx].style;
               const barTwoStyle = arrayBars[barTwoIdx].style;
               const color =  i % 3 === 0? 'red' : 'turquoise';
               setTimeout( () => {
                   barOneStyle.backgroundColor = color;
                   barTwoStyle.backgroundColor = color;
               },i*ANIMATION_SPEED_MS); 
           } else {
                setTimeout(() => {
                    const[barOneIdx,newHeight] = animations[i];
                    const barOneStyle  = arrayBars[barOneIdx].style; 
                    barOneStyle.height = `${newHeight}px`;
                },i*ANIMATION_SPEED_MS); 
           }
       }
     }

    function arrayAreEqual(arrayOne,arrayTwo){
        if(arrayOne.length !== arrayTwo.length) return false;
        for(let i=0;i<arrayOne.length;i++){
            if(arrayOne[i] !== arrayTwo[i]) return false;
        }
         return true;
    }

     function testSortingAlgorithms(){
         for(let i=0;i<100;i++){
             const array = [];
             const length = Math.floor(Math.random() * (1000 - 1) + 1);
             for(let i=0;i<length;i++){
                 array.push(Math.floor(Math.random() * (1000 - (-1000)) + (-1000)) );
             }
             const javaScriptSortedArray = array.slice().sort((a,b) => a-b);
             const mergeSortedArray = getMergeSortAnimations(array.slice());
             console.log(arrayAreEqual(javaScriptSortedArray,mergeSortedArray));
         }
     }

    return (
      <div> 
        <div className="array-container">
           { array.map((x,idx) => {
              return <div className='array-bar' key={idx} style={{height: `${x}px`}}>
              </div>
            })}
        </div>
       <button onClick={handleClick}>Generate </button>
       <button onClick={mergesort}>MergeSort</button>
       <button onClick={testSortingAlgorithms}>testSortingAlgorithms</button>
      </div>
    );
  
}

export default SortingAnalyzer;
